import script from "./LottScanMain.vue?vue&type=script&setup=true&lang=js"
export * from "./LottScanMain.vue?vue&type=script&setup=true&lang=js"

import "./LottScanMain.vue?vue&type=style&index=0&id=95f3b578&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95f3b578"]])

export default __exports__